import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {APP_ENVIRONMENT} from "../../../chat-common/src/lib/services/environment.service";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getFirestore, provideFirestore} from "@angular/fire/firestore";
import {getDatabase, provideDatabase} from "@angular/fire/database";
import {getAuth, provideAuth} from "@angular/fire/auth";
import { inject, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS, HttpHandler, HttpRequest, HttpEvent } from "@angular/common/http";
import {environment} from '../environments/environment';
import { DatePipe } from '@angular/common';
import {AccountLibraryModule, environmentDev, environmentProd, environmentStage} from '@bellabeat/account-library';
import { authInterceptor } from "../../../chat-common/src/lib/interceptors/auth.interceptor";
import { openAiInterceptor } from './chat-gpt/services/openai.interceptor';
import { accessCodeFragmentInitializer } from './access-code-fragment.initializer';

/**
 * Legacy wrapper for the functional interceptor to support any part of the app
 * that might still be using legacy HttpClientModule.
 */
@Injectable()
export class AuthInterceptorLegacyWrapper {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return authInterceptor(req, (r) => next.handle(r));
  }
}

const env = environment.app === 'local' ? environmentDev : (environment.app === 'stage' ? environmentStage : environmentProd);
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AccountLibraryModule.configure(env),
  ],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor, openAiInterceptor]),
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorLegacyWrapper,
      multi: true
    },
    { provide: APP_ENVIRONMENT, useValue: environment },
    accessCodeFragmentInitializer,
    DatePipe,

    provideFirebaseApp(() => initializeApp(environment.firebase)),  // Use environment config
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    provideAuth(() => getAuth()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
